import React, { useReducer } from 'react'

import LayoutContext from './contexts'
import LayoutReducer from './reducers'

import { TOGGLE_SIDEBAR } from './actions'

const initialState = {
    activeSidebar: true
}

const LayoutStore = ({ children }) => {
    const [state, dispatch] = useReducer(LayoutReducer, initialState)

    const sidebarToggleHandler = () => dispatch({type: TOGGLE_SIDEBAR})

    return (
        <LayoutContext.Provider value={{
            activeSidebar: state.activeSidebar,
            sidebarToggleHandler
        }}>
            { children }
        </LayoutContext.Provider>
    )
}



export default LayoutStore